import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Consulte as informações de ")
const _hoisted_2 = /*#__PURE__*/_createElementVNode("b", null, "produtos", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" aqui ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" So apontar para o ")
const _hoisted_5 = /*#__PURE__*/_createElementVNode("b", null, "QRCODE", -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" disponível no produto ")
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "b4" }, "*função disponível em algumas lojas físicas", -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Ler outro código de Barras ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Salvar esta lista ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SafeArea = _resolveComponent("SafeArea")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_modal = _resolveComponent("ion-modal")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_Produto = _resolveComponent("Produto")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_SafeArea, {
        onOnBack: _cache[0] || (_cache[0] = ($event: any) => (_ctx.voltar(_ctx.router))),
        data: {'cart': false}
      }),
      _createVNode(_component_ion_modal, {
        ref: "modal",
        trigger: "open-modal",
        "is-open": _ctx.isOpenAtivacao,
        "initial-breakpoint": 0.50,
        breakpoints: [0, 0.25, 0.5, 0.75]
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_content, { class: "ion-padding" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, {
                    class: "ion-text-center b1",
                    size: "12"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, {
                        class: "ion-icon",
                        icon: _ctx.icon_qr
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, {
                    class: "b2",
                    size: "12"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_1,
                      _hoisted_2,
                      _hoisted_3
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, {
                    class: "b3",
                    size: "12"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_4,
                      _hoisted_5,
                      _hoisted_6
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _hoisted_7
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["is-open", "initial-breakpoint", "breakpoints"]),
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_row, { class: "ion-align-items-center" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_col, {
                size: "12",
                class: "ion-text-center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_button, {
                    shape: "jau",
                    color: "jauservelayoutalter",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.startScan(_ctx.router)))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_8
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_col, {
                size: "12",
                class: "ion-text-center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_button, {
                    shape: "jau",
                    color: "jauservelayoutalter",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.salvarLista()))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_9,
                      (_ctx.onSave)
                        ? (_openBlock(), _createBlock(_component_ion_spinner, { key: 0 }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.produtos, (produto, index) => {
                return (_openBlock(), _createBlock(_component_ion_col, {
                  class: "produto ion-text-center",
                  size: _ctx.produtos.length==1?12:6,
                  key: 'c'+index
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Produto, { produto: produto }, null, 8, ["produto"])
                  ]),
                  _: 2
                }, 1032, ["size"]))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}